import * as genericUtils from '@tolk-ai/generic-utils';
import * as browserUtils from '@tolk-ai/browser-utils';

var GetManySmartSkillsErrors;

(function (GetManySmartSkillsErrors) {
  GetManySmartSkillsErrors[GetManySmartSkillsErrors["inexistingBot"] = 0] = "inexistingBot";
})(GetManySmartSkillsErrors || (GetManySmartSkillsErrors = {}));

var GetSmartSkillFormDetailsErrors;

(function (GetSmartSkillFormDetailsErrors) {
  GetSmartSkillFormDetailsErrors[GetSmartSkillFormDetailsErrors["inexistingBot"] = 0] = "inexistingBot";
})(GetSmartSkillFormDetailsErrors || (GetSmartSkillFormDetailsErrors = {}));

var GetOneSmartSkillInfosErrors;

(function (GetOneSmartSkillInfosErrors) {
  GetOneSmartSkillInfosErrors[GetOneSmartSkillInfosErrors["inexistingSmartSkill"] = 0] = "inexistingSmartSkill";
})(GetOneSmartSkillInfosErrors || (GetOneSmartSkillInfosErrors = {}));

var CreateOneSmartSkillErrors;

(function (CreateOneSmartSkillErrors) {
  CreateOneSmartSkillErrors[CreateOneSmartSkillErrors["inexistingBot"] = 0] = "inexistingBot";
  CreateOneSmartSkillErrors[CreateOneSmartSkillErrors["emptyName"] = 1] = "emptyName";
  CreateOneSmartSkillErrors[CreateOneSmartSkillErrors["emptyQuestions"] = 2] = "emptyQuestions";
  CreateOneSmartSkillErrors[CreateOneSmartSkillErrors["invalidSmartSkill"] = 3] = "invalidSmartSkill";
})(CreateOneSmartSkillErrors || (CreateOneSmartSkillErrors = {}));

var UpdateOneSmartSkillErrors;

(function (UpdateOneSmartSkillErrors) {
  UpdateOneSmartSkillErrors[UpdateOneSmartSkillErrors["inexistingSmartSkill"] = 0] = "inexistingSmartSkill";
  UpdateOneSmartSkillErrors[UpdateOneSmartSkillErrors["emptyName"] = 1] = "emptyName";
  UpdateOneSmartSkillErrors[UpdateOneSmartSkillErrors["emptyQuestions"] = 2] = "emptyQuestions";
  UpdateOneSmartSkillErrors[UpdateOneSmartSkillErrors["invalidSmartSkill"] = 3] = "invalidSmartSkill";
})(UpdateOneSmartSkillErrors || (UpdateOneSmartSkillErrors = {}));

var applicationPorts = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get CreateOneSmartSkillErrors () { return CreateOneSmartSkillErrors; },
  get GetManySmartSkillsErrors () { return GetManySmartSkillsErrors; },
  get GetOneSmartSkillInfosErrors () { return GetOneSmartSkillInfosErrors; },
  get GetSmartSkillFormDetailsErrors () { return GetSmartSkillFormDetailsErrors; },
  get UpdateOneSmartSkillErrors () { return UpdateOneSmartSkillErrors; }
});

const getRestManySmartSkill = authenticatedRequest => async botId => {
  try {
    return await authenticatedRequest('get', `/v1/bots/${botId}/smart-skills`);
  } catch (error) {
    if (browserUtils.isAxiosRestError(error)) {
      switch (error.response.data.error) {
        case 'inexistingBot':
          return GetManySmartSkillsErrors.inexistingBot;
      }
    }

    throw genericUtils.sanitizeError(error);
  }
};

const getRestOneSmartSkillInfos = authenticatedRequest => async (botId, smartSkillId) => {
  try {
    return await authenticatedRequest('get', `/v1/bots/${botId}/smart-skills/${smartSkillId}/infos`);
  } catch (error) {
    if (browserUtils.isAxiosRestError(error)) {
      switch (error.response.data.error) {
        case 'inexistingSmartSkill':
          return GetOneSmartSkillInfosErrors.inexistingSmartSkill;
      }
    }

    throw genericUtils.sanitizeError(error);
  }
};

const getRestSmartSkillFormDetails = authenticatedRequest => async botId => {
  try {
    return await authenticatedRequest('get', `/v1/bots/${botId}/smart-skills-form-details`);
  } catch (error) {
    if (browserUtils.isAxiosRestError(error)) {
      switch (error.response.data.error) {
        case 'inexistingBot':
          return GetSmartSkillFormDetailsErrors.inexistingBot;
      }
    }

    throw genericUtils.sanitizeError(error);
  }
};

const restCreateOneSmartSkill = authenticatedRequest => async (botId, smartSkillData) => {
  try {
    return await authenticatedRequest('post', `/v1/bots/${botId}/smart-skills`, smartSkillData);
  } catch (error) {
    if (browserUtils.isAxiosRestError(error)) {
      switch (error.response.data.error) {
        case 'inexistingBot':
          return CreateOneSmartSkillErrors.inexistingBot;

        case 'emptyName':
          return CreateOneSmartSkillErrors.emptyName;

        case 'emptyQuestions':
          return CreateOneSmartSkillErrors.emptyQuestions;

        case 'invalidSmartSkill':
          return CreateOneSmartSkillErrors.invalidSmartSkill;
      }
    }

    throw genericUtils.sanitizeError(error);
  }
};

const restUpdateOneSmartSkill = authenticatedRequest => async (botId, smartSkillId, smartSkillData) => {
  try {
    return await authenticatedRequest('put', `/v1/bots/${botId}/smart-skills/${smartSkillId}`, smartSkillData);
  } catch (error) {
    if (browserUtils.isAxiosRestError(error)) {
      switch (error.response.data.error) {
        case 'inexistingSmartSkill':
          return UpdateOneSmartSkillErrors.inexistingSmartSkill;

        case 'emptyName':
          return UpdateOneSmartSkillErrors.emptyName;

        case 'emptyQuestions':
          return UpdateOneSmartSkillErrors.emptyQuestions;

        case 'invalidSmartSkill':
          return UpdateOneSmartSkillErrors.invalidSmartSkill;
      }
    }

    throw genericUtils.sanitizeError(error);
  }
};

const convertRestSmartSkillInfosToSmartSkillInfos = restSmartSkillInfos => ({
  answers: restSmartSkillInfos.answers,
  botId: restSmartSkillInfos.botId,
  details: restSmartSkillInfos.details,
  id: restSmartSkillInfos.id,
  name: restSmartSkillInfos.name,
  questions: restSmartSkillInfos.questions
});

const convertManyRestSmartSkillToSmartSkill = manyRestSmartSkill => manyRestSmartSkill.map(restSmartSkill => ({
  answers: restSmartSkill.answers,
  botId: restSmartSkill.botId,
  id: restSmartSkill.id,
  name: restSmartSkill.name,
  questions: restSmartSkill.questions
}));

const convertRestCustomerApiDetailGetToCustomerApiDetailGet = restCustomerApiDetailGet => ({
  inputs: restCustomerApiDetailGet.inputs,
  method: restCustomerApiDetailGet.method,
  outputs: restCustomerApiDetailGet.outputs
});

const convertRestCustomerApiDetailPostToCustomerApiDetailPost = restCustomerApiDetailPost => ({
  body: restCustomerApiDetailPost.body,
  inputs: restCustomerApiDetailPost.inputs,
  method: restCustomerApiDetailPost.method,
  outputs: restCustomerApiDetailPost.outputs
});

const convertRestCustomerApiDetailToCustomerApiDetail = restCustomerApiDetails => {
  switch (restCustomerApiDetails.method) {
    case 'GET':
      return convertRestCustomerApiDetailGetToCustomerApiDetailGet(restCustomerApiDetails);

    default:
      return convertRestCustomerApiDetailPostToCustomerApiDetailPost(restCustomerApiDetails);
  }
};

const convertRestCustomerApiInfoToCustomerApiInfo = restSmartSkillFormDetails => ({
  details: convertRestCustomerApiDetailToCustomerApiDetail(restSmartSkillFormDetails.details),
  id: restSmartSkillFormDetails.id,
  name: restSmartSkillFormDetails.name
});

const convertRestSmartSkillFormDetailsToSmartSkillFormDetails = restSmartSkillFormDetails => ({
  apis: restSmartSkillFormDetails.apis.map(restCustomerApiInfo => convertRestCustomerApiInfoToCustomerApiInfo(restCustomerApiInfo)),
  questions: restSmartSkillFormDetails.questions
});

const getManySmartSkills$1 = authenticatedRequest => async botId => {
  const result = await getRestManySmartSkill(authenticatedRequest)(botId);

  if (genericUtils.isDomainError(result, GetManySmartSkillsErrors)) {
    return result;
  }

  return convertManyRestSmartSkillToSmartSkill(result);
};

const getOneSmartSkillInfos$2 = authenticatedRequest => async (botId, smartSkillId) => {
  const result = await getRestOneSmartSkillInfos(authenticatedRequest)(botId, smartSkillId);

  if (genericUtils.isDomainError(result, GetOneSmartSkillInfosErrors)) {
    return result;
  }

  return convertRestSmartSkillInfosToSmartSkillInfos(result);
};

const getSmartSkillFormDetails$1 = authenticatedRequest => async botId => {
  const result = await getRestSmartSkillFormDetails(authenticatedRequest)(botId);

  if (genericUtils.isDomainError(result, GetSmartSkillFormDetailsErrors)) {
    return result;
  }

  return convertRestSmartSkillFormDetailsToSmartSkillFormDetails(result);
};

const createOneSmartSkill$1 = authenticatedRequest => async (botId, smartSkillData) => {
  const result = await restCreateOneSmartSkill(authenticatedRequest)(botId, smartSkillData);

  if (genericUtils.isDomainError(result, CreateOneSmartSkillErrors)) {
    return result;
  }

  return result;
};

const updateOneSmartSkill$1 = authenticatedRequest => async (botId, smartSkillId, smartSkillData) => {
  return restUpdateOneSmartSkill(authenticatedRequest)(botId, smartSkillId, smartSkillData);
};

var index$8 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createOneSmartSkill: createOneSmartSkill$1,
  getManySmartSkills: getManySmartSkills$1,
  getOneSmartSkillInfos: getOneSmartSkillInfos$2,
  getSmartSkillFormDetails: getSmartSkillFormDetails$1,
  updateOneSmartSkill: updateOneSmartSkill$1
});

const getOneMongoBotByBotId = mongodb => async botId => {
  try {
    return await mongodb.collection('api_bots').findOne({
      bot_id: botId
    }, {
      projection: {
        _id: 0,
        bot_id: 1
      }
    });
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const setValueModifiedOnOneMongoBot = mongodb => async botId => {
  try {
    await mongodb.collection('api_bots').updateOne({
      bot_id: botId
    }, {
      $set: {
        modified: true
      }
    });
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertMongoBotToBot = persistedMongoBot => ({
  id: persistedMongoBot.bot_id
});

const getOneBotById = mongodb => async botId => {
  const result = await getOneMongoBotByBotId(mongodb)(botId);

  if (!result) {
    return null;
  }

  return convertMongoBotToBot(result);
};

const setValueModifiedOnOneBot = mongodb => async botId => {
  await setValueModifiedOnOneMongoBot(mongodb)(botId);
};

var index$7 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getOneBotById: getOneBotById,
  setValueModifiedOnOneBot: setValueModifiedOnOneBot
});

const getOnePgCustomerApiByBotIdAndCustomerApiId = pool => async (botId, customerApiId) => {
  var _a;

  try {
    const result = await pool.query(`SELECT
          customer_api_id
        FROM customer_api
        WHERE bot_id = $1 AND customer_api_id = $2 ;`, [botId, customerApiId]);
    return (_a = result.rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getManyPgCustomerApiInputsByCustomerApiId = pool => async customerApiId => {
  try {
    const result = await pool.query(`SELECT
          name,
          format
        FROM customer_api_data
        WHERE customer_api_id = (SELECT id FROM customer_api WHERE customer_api_id = $1)
        AND type = 'input';`, [customerApiId]);
    return result.rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertPgCustomerApiInputToCustomerApiInput = pgCustomerApi => ({
  name: pgCustomerApi.name,
  type: pgCustomerApi.format
});

const convertManyPgCustomerApiInputsToCustomerApiInput = pgCustomerApiInputs => pgCustomerApiInputs.map(pgCustomerApiInput => convertPgCustomerApiInputToCustomerApiInput(pgCustomerApiInput));

const getOneCustomerApiByIdAndBotId = pool => async (botId, customerApiId) => {
  const pgCustomerApi = await getOnePgCustomerApiByBotIdAndCustomerApiId(pool)(botId, customerApiId);

  if (pgCustomerApi === null) {
    return null;
  }

  return pgCustomerApi.customer_api_id;
};

const getManyCustomerApiInputsByCustomerApiId = pool => async customerApiId => {
  const pgCustomerApi = await getManyPgCustomerApiInputsByCustomerApiId(pool)(customerApiId);
  return convertManyPgCustomerApiInputsToCustomerApiInput(pgCustomerApi);
};

var index$6 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getManyCustomerApiInputsByCustomerApiId: getManyCustomerApiInputsByCustomerApiId,
  getOneCustomerApiByIdAndBotId: getOneCustomerApiByIdAndBotId
});

const getOnePgQuestionByQuestionId = pool => async questionId => {
  var _a;

  try {
    const result = await pool.query(`SELECT
        question_id,
        bot_id,
        text
      FROM question
      WHERE question_id = $1;`, [questionId]);
    return (_a = result.rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertPgQuestionToQuestion$2 = pgQuestion => ({
  id: pgQuestion.question_id,
  text: pgQuestion.text
});

const getOneQuestionByIdAndBotId = pool => async questionId => {
  const pgQuestion = await getOnePgQuestionByQuestionId(pool)(questionId);

  if (pgQuestion === null) {
    return null;
  }

  return convertPgQuestionToQuestion$2(pgQuestion);
};

var index$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getOneQuestionByIdAndBotId: getOneQuestionByIdAndBotId
});

const getManySmartSkill = mongodb => async botId => {
  try {
    return await mongodb.collection('smart_skills').find({
      bot_id: botId
    }, {
      projection: {
        _id: 0,
        answers: 1,
        bot_id: 1,
        name: 1,
        questions: 1,
        smart_skill_id: 1
      }
    }).toArray();
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOneSmartSkill = mongodb => async (botId, smartSkillId) => {
  try {
    return await mongodb.collection('smart_skills').findOne({
      bot_id: botId,
      smart_skill_id: smartSkillId
    }, {
      projection: {
        _id: 0,
        answers: 1,
        bot_id: 1,
        name: 1,
        questions: 1,
        smart_skill_id: 1
      }
    });
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const saveOneMongoSmartSkill = mongodb => async mongoSmartSkill => {
  try {
    await mongodb.collection('smart_skills').updateOne({
      smart_skill_id: mongoSmartSkill.smart_skill_id
    }, {
      $set: Object.assign({}, mongoSmartSkill)
    }, {
      upsert: true
    });
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertMongoSmartSkillQuestionButtonChoiceToQuestionButtonChoice$1 = mongoSmartSkillQuestionButtonChoice => ({
  assignment: mongoSmartSkillQuestionButtonChoice.assignment.name,
  title: mongoSmartSkillQuestionButtonChoice.label
});

const convertMongoSmartSkillQuestionToQuestionData$1 = mongoSmartSkillQuestion => {
  switch (mongoSmartSkillQuestion.type) {
    case 'text':
      return {
        assignment: mongoSmartSkillQuestion.assignment.name,
        title: mongoSmartSkillQuestion.label,
        type: 'text'
      };

    case 'qr':
      return {
        assignment: mongoSmartSkillQuestion.assignment.name,
        buttons: mongoSmartSkillQuestion.buttons.map(button => convertMongoSmartSkillQuestionButtonChoiceToQuestionButtonChoice$1(button)),
        title: mongoSmartSkillQuestion.label,
        type: 'qr'
      };

    default:
      return {
        id: mongoSmartSkillQuestion.customer_api_id,
        inputs: [],
        type: 'customer-api'
      };
  }
};

const convertMongoSmartSkillAnswerScenarioToScenarioContent$1 = mongoSmartSkillAnswerScenario => {
  switch (mongoSmartSkillAnswerScenario.operator) {
    case 'exist':
      return {
        operator: mongoSmartSkillAnswerScenario.operator,
        target: mongoSmartSkillAnswerScenario.assignment.name
      };

    default:
      return {
        match: mongoSmartSkillAnswerScenario.match,
        operator: mongoSmartSkillAnswerScenario.operator,
        target: mongoSmartSkillAnswerScenario.assignment.name
      };
  }
};

const convertMongoSmartSkillAnswerScenarioToScenario$1 = mongoSmartSkillAnswerScenario => {
  switch (mongoSmartSkillAnswerScenario.type) {
    case 'text':
      return {
        content: convertMongoSmartSkillAnswerScenarioToScenarioContent$1(mongoSmartSkillAnswerScenario),
        type: 'free_input'
      };

    case 'button':
      return {
        content: convertMongoSmartSkillAnswerScenarioToScenarioContent$1(mongoSmartSkillAnswerScenario),
        type: 'button'
      };

    default:
      return {
        content: convertMongoSmartSkillAnswerScenarioToScenarioContent$1(mongoSmartSkillAnswerScenario),
        reference: mongoSmartSkillAnswerScenario.reference,
        type: 'customer_api'
      };
  }
};

const convertMongoSmartSkillAnswerDataChoiceButtonToAnswerDataChoiceButton$1 = mongoSmartSkillAnswerDataChoiceButton => {
  switch (mongoSmartSkillAnswerDataChoiceButton.type) {
    case 'question':
      return {
        questionId: mongoSmartSkillAnswerDataChoiceButton.questionId,
        title: mongoSmartSkillAnswerDataChoiceButton.title,
        type: 'question'
      };

    default:
      return {
        target: mongoSmartSkillAnswerDataChoiceButton.target,
        title: mongoSmartSkillAnswerDataChoiceButton.title,
        type: 'url',
        url: mongoSmartSkillAnswerDataChoiceButton.url
      };
  }
};

const convertMongoSmartSkillAnswerContentToAnswerData$1 = mongoSmartSkillAnswerContent => {
  switch (mongoSmartSkillAnswerContent.type) {
    case 'text':
      return {
        title: mongoSmartSkillAnswerContent.label,
        type: 'text'
      };

    case 'button':
      return {
        buttons: mongoSmartSkillAnswerContent.buttons.map(button => convertMongoSmartSkillAnswerDataChoiceButtonToAnswerDataChoiceButton$1(button)),
        title: mongoSmartSkillAnswerContent.label,
        type: 'button'
      };

    default:
      return {
        id: mongoSmartSkillAnswerContent.id,
        type: 'customer-api'
      };
  }
};

const convertMongoSmartSkillAnswerToSmartSkillAnswer$1 = mongoSmartSkillAnswer => ({
  answers: mongoSmartSkillAnswer.answer.content.map(contentItem => convertMongoSmartSkillAnswerContentToAnswerData$1(contentItem)),
  scenarios: mongoSmartSkillAnswer.scenarios.map(scenario => convertMongoSmartSkillAnswerScenarioToScenario$1(scenario))
});

const convertMongoSmartSkillToSmartSkill = mongoSmartSkill => ({
  answers: mongoSmartSkill.answers.map(answer => convertMongoSmartSkillAnswerToSmartSkillAnswer$1(answer)),
  botId: mongoSmartSkill.bot_id,
  id: mongoSmartSkill.smart_skill_id,
  name: mongoSmartSkill.name,
  questions: mongoSmartSkill.questions.map(question => convertMongoSmartSkillQuestionToQuestionData$1(question))
});

const convertManyMongoSmartSkillToManySmartSkill = manyMongoSmartSkill => {
  return manyMongoSmartSkill.map(mongoSmartSkill => convertMongoSmartSkillToSmartSkill(mongoSmartSkill));
};

const convertAnswerDataChoiceButtonToMongoSmartSkillAnswerDataChoiceButton = answerDataChoiceButton => {
  switch (answerDataChoiceButton.type) {
    case 'question':
      return {
        questionId: answerDataChoiceButton.questionId,
        title: answerDataChoiceButton.title,
        type: 'question'
      };

    default:
      return {
        target: answerDataChoiceButton.target,
        title: answerDataChoiceButton.title,
        type: 'url',
        url: answerDataChoiceButton.url
      };
  }
};

const convertAnswerDataToMongoSmartSkillAnswerContent = answerData => {
  switch (answerData.type) {
    case 'text':
      return {
        id: genericUtils.generateUniqueId(),
        label: answerData.title,
        type: 'text'
      };

    case 'button':
      return {
        buttons: answerData.buttons.map(button => convertAnswerDataChoiceButtonToMongoSmartSkillAnswerDataChoiceButton(button)),
        id: genericUtils.generateUniqueId(),
        label: answerData.title,
        type: 'button'
      };

    default:
      return {
        customer_api_id: answerData.id,
        id: genericUtils.generateUniqueId(),
        type: 'customer-api'
      };
  }
};

const convertSmartSkillAnswerToMongoSmartSkillAnswer = manyAnswerData => ({
  content: manyAnswerData.map(answerData => convertAnswerDataToMongoSmartSkillAnswerContent(answerData)),
  id: genericUtils.generateUniqueId()
});

const convertScenarioContentToMongoSmartSkillAnswerScenario = scenarioContent => {
  switch (scenarioContent.operator) {
    case 'exist':
      return {
        assignment: {
          id: genericUtils.generateUniqueId(),
          name: scenarioContent.target
        },
        id: genericUtils.generateUniqueId(),
        operator: scenarioContent.operator
      };

    default:
      return {
        assignment: {
          id: genericUtils.generateUniqueId(),
          name: scenarioContent.target
        },
        id: genericUtils.generateUniqueId(),
        match: scenarioContent.match,
        operator: scenarioContent.operator
      };
  }
};

const convertManyScenarioToMongoSmartSkillAnswerScenario = manyScenario => {
  return manyScenario.map(scenario => {
    switch (scenario.type) {
      case 'free_input':
        return Object.assign(Object.assign({}, convertScenarioContentToMongoSmartSkillAnswerScenario(scenario.content)), {
          type: 'text'
        });

      case 'button':
        return Object.assign(Object.assign({}, convertScenarioContentToMongoSmartSkillAnswerScenario(scenario.content)), {
          type: 'button'
        });

      default:
        return Object.assign(Object.assign({}, convertScenarioContentToMongoSmartSkillAnswerScenario(scenario.content)), {
          reference: scenario.reference,
          type: 'customer_api'
        });
    }
  });
};

const convertManySmartSkillAnswerToManyMongoSmartSkillAnswer = manySmartSkillAnswer => {
  return manySmartSkillAnswer.map(smartSkillAnswer => ({
    answer: convertSmartSkillAnswerToMongoSmartSkillAnswer(smartSkillAnswer.answers),
    scenarios: convertManyScenarioToMongoSmartSkillAnswerScenario(smartSkillAnswer.scenarios)
  }));
};

const convertQuestionButtonChoiceToMongoSmartSkillQuestionButtonChoice = questionButtonChoice => ({
  assignment: {
    id: genericUtils.generateUniqueId(),
    name: questionButtonChoice.assignment
  },
  id: genericUtils.generateUniqueId(),
  label: questionButtonChoice.title,
  type: 'payload'
});

const convertManyQuestionDataToManyMongoSmartSkillQuestion = manyQuestionData => {
  return manyQuestionData.map(questionData => {
    switch (questionData.type) {
      case 'text':
        return {
          assignment: {
            id: genericUtils.generateUniqueId(),
            name: questionData.assignment
          },
          id: genericUtils.generateUniqueId(),
          label: questionData.title,
          type: 'text'
        };

      case 'qr':
        return {
          assignment: {
            id: genericUtils.generateUniqueId(),
            name: questionData.assignment
          },
          buttons: questionData.buttons.map(button => convertQuestionButtonChoiceToMongoSmartSkillQuestionButtonChoice(button)),
          id: genericUtils.generateUniqueId(),
          label: questionData.title,
          type: 'qr'
        };

      default:
        return {
          customer_api_id: questionData.id,
          id: genericUtils.generateUniqueId(),
          inputs: [],
          type: 'customer-api'
        };
    }
  });
};

const convertSmartSkillToMongoSmartSkill = smartSkill => ({
  answers: convertManySmartSkillAnswerToManyMongoSmartSkillAnswer(smartSkill.answers),
  bot_id: smartSkill.botId,
  name: smartSkill.name,
  questions: convertManyQuestionDataToManyMongoSmartSkillQuestion(smartSkill.questions),
  smart_skill_id: smartSkill.id
});

const getManySmartSkillsByBotId = mongodb => async botId => {
  const result = await getManySmartSkill(mongodb)(botId);
  return convertManyMongoSmartSkillToManySmartSkill(result);
};

const saveSmartSkill = mongodb => async smartSkill => {
  const mongoSmartSkill = convertSmartSkillToMongoSmartSkill(smartSkill);
  await saveOneMongoSmartSkill(mongodb)(mongoSmartSkill);
};

const getOneSmartSkillByBotIdAndId = mongodb => async (botId, smartSkillId) => {
  const smartSkill = await getOneSmartSkill(mongodb)(botId, smartSkillId);

  if (smartSkill === null) {
    return null;
  }

  return convertMongoSmartSkillToSmartSkill(smartSkill);
};

var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getManySmartSkillsByBotId: getManySmartSkillsByBotId,
  getOneSmartSkillByBotIdAndId: getOneSmartSkillByBotIdAndId,
  saveSmartSkill: saveSmartSkill
});

const getOneSmartSkillInfos$1 = mongodb => async (botId, smartSkillId) => {
  try {
    return await mongodb.collection('smart_skills').findOne({
      bot_id: botId,
      smart_skill_id: smartSkillId
    }, {
      projection: {
        _id: 0,
        answers: 1,
        bot_id: 1,
        name: 1,
        questions: 1,
        smart_skill_id: 1
      }
    });
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getManyPgCustomerApiByBotId$1 = pool => async botId => {
  try {
    const result = await pool.query(`SELECT
        customer_api_id,
        method,
        name,
        body
      FROM customer_api
      WHERE bot_id = $1
      ORDER BY id ASC;`, [botId]);
    return result.rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getManyPgCustomerApiDataByCustomerApiId$1 = pool => async customerApiId => {
  try {
    const result = await pool.query(`SELECT
          name,
          "format",
          type
        FROM customer_api_data
        WHERE customer_api_id = (SELECT id FROM customer_api WHERE customer_api_id = $1)
        AND type IN('input', 'output');`, [customerApiId]);
    return result.rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getManyPgCustomerApiData = pool => async pgCustomerApis => Promise.all(pgCustomerApis.map(async pgCustomerApi => {
  const manyPgCustomerApiData = await getManyPgCustomerApiDataByCustomerApiId$1(pool)(pgCustomerApi.customer_api_id);
  const inputs = manyPgCustomerApiData.filter(pgCustomerApiData => pgCustomerApiData.type === 'input');
  const outputs = manyPgCustomerApiData.filter(pgCustomerApiData => pgCustomerApiData.type === 'output');
  return Object.assign(Object.assign({}, pgCustomerApi), {
    inputs,
    outputs
  });
}));

const getManyPgQuestionByBotId$1 = pool => async botId => {
  try {
    const result = await pool.query(`SELECT
        question_id,
        bot_id,
        text
      FROM question
      WHERE bot_id = (SELECT bot.id FROM bot WHERE bot.bot_id = $1)
      ORDER BY text ASC;`, [botId]);
    return result.rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertMongoSmartSkillAnswerDataChoiceButtonToAnswerDataChoiceButton = mongoSmartSkillAnswerDataChoiceButton => {
  switch (mongoSmartSkillAnswerDataChoiceButton.type) {
    case 'question':
      return {
        questionId: mongoSmartSkillAnswerDataChoiceButton.questionId,
        title: mongoSmartSkillAnswerDataChoiceButton.title,
        type: 'question'
      };

    default:
      return {
        target: mongoSmartSkillAnswerDataChoiceButton.target,
        title: mongoSmartSkillAnswerDataChoiceButton.title,
        type: 'url',
        url: mongoSmartSkillAnswerDataChoiceButton.url
      };
  }
};

const convertMongoSmartSkillAnswerContentToAnswerData = mongoSmartSkillAnswerContent => {
  switch (mongoSmartSkillAnswerContent.type) {
    case 'text':
      return {
        title: mongoSmartSkillAnswerContent.label,
        type: 'text'
      };

    case 'button':
      return {
        buttons: mongoSmartSkillAnswerContent.buttons.map(button => convertMongoSmartSkillAnswerDataChoiceButtonToAnswerDataChoiceButton(button)),
        title: mongoSmartSkillAnswerContent.label,
        type: 'button'
      };

    default:
      return {
        id: mongoSmartSkillAnswerContent.customer_api_id,
        type: 'customer-api'
      };
  }
};

const convertMongoSmartSkillAnswerScenarioToScenarioContent = mongoSmartSkillAnswerScenario => {
  switch (mongoSmartSkillAnswerScenario.operator) {
    case 'exist':
      return {
        operator: mongoSmartSkillAnswerScenario.operator,
        target: mongoSmartSkillAnswerScenario.assignment.name
      };

    default:
      return {
        match: mongoSmartSkillAnswerScenario.match,
        operator: mongoSmartSkillAnswerScenario.operator,
        target: mongoSmartSkillAnswerScenario.assignment.name
      };
  }
};

const convertMongoSmartSkillAnswerScenarioToScenario = mongoSmartSkillAnswerScenario => {
  switch (mongoSmartSkillAnswerScenario.type) {
    case 'text':
      return {
        content: convertMongoSmartSkillAnswerScenarioToScenarioContent(mongoSmartSkillAnswerScenario),
        type: 'free_input'
      };

    case 'button':
      return {
        content: convertMongoSmartSkillAnswerScenarioToScenarioContent(mongoSmartSkillAnswerScenario),
        type: 'button'
      };

    default:
      return {
        content: convertMongoSmartSkillAnswerScenarioToScenarioContent(mongoSmartSkillAnswerScenario),
        reference: mongoSmartSkillAnswerScenario.reference,
        type: 'customer_api'
      };
  }
};

const convertMongoSmartSkillQuestionButtonChoiceToQuestionButtonChoice = mongoSmartSkillQuestionButtonChoice => ({
  assignment: mongoSmartSkillQuestionButtonChoice.assignment.name,
  title: mongoSmartSkillQuestionButtonChoice.label
});

const convertMongoSmartSkillQuestionToQuestionData = mongoSmartSkillQuestion => {
  switch (mongoSmartSkillQuestion.type) {
    case 'text':
      return {
        assignment: mongoSmartSkillQuestion.assignment.name,
        title: mongoSmartSkillQuestion.label,
        type: 'text'
      };

    case 'qr':
      return {
        assignment: mongoSmartSkillQuestion.assignment.name,
        buttons: mongoSmartSkillQuestion.buttons.map(button => convertMongoSmartSkillQuestionButtonChoiceToQuestionButtonChoice(button)),
        title: mongoSmartSkillQuestion.label,
        type: 'qr'
      };

    default:
      return {
        id: mongoSmartSkillQuestion.customer_api_id,
        inputs: [],
        type: 'customer-api'
      };
  }
};

const convertMongoSmartSkillAnswerToSmartSkillAnswer = mongoSmartSkillAnswer => ({
  answers: mongoSmartSkillAnswer.answer.content.map(contentItem => convertMongoSmartSkillAnswerContentToAnswerData(contentItem)),
  scenarios: mongoSmartSkillAnswer.scenarios.map(scenario => convertMongoSmartSkillAnswerScenarioToScenario(scenario))
});

const convertPgCustomerApiDataInputToCustomerApiInput$1 = pgCustomerApiDataInput => ({
  name: pgCustomerApiDataInput.name,
  type: pgCustomerApiDataInput.format
});

const convertPgCustomerApiDataOutputToCustomerApiOutput$1 = pgCustomerApiDataOutput => ({
  name: pgCustomerApiDataOutput.name,
  type: pgCustomerApiDataOutput.format
});

const convertPgCustomerApiInfosToCustomerApiDetail$1 = pgCustomerApiInfos => {
  switch (pgCustomerApiInfos.method) {
    case 'GET':
      return {
        inputs: pgCustomerApiInfos.inputs.map(input => convertPgCustomerApiDataInputToCustomerApiInput$1(input)),
        method: pgCustomerApiInfos.method,
        outputs: pgCustomerApiInfos.outputs.map(output => convertPgCustomerApiDataOutputToCustomerApiOutput$1(output))
      };

    default:
      return {
        body: pgCustomerApiInfos.body,
        inputs: pgCustomerApiInfos.inputs.map(input => convertPgCustomerApiDataInputToCustomerApiInput$1(input)),
        method: pgCustomerApiInfos.method,
        outputs: pgCustomerApiInfos.outputs.map(output => convertPgCustomerApiDataOutputToCustomerApiOutput$1(output))
      };
  }
};

const convertPgCustomerApiInfosToCustomerApiInfo$1 = pgCustomerApiInfos => ({
  details: convertPgCustomerApiInfosToCustomerApiDetail$1(pgCustomerApiInfos),
  id: pgCustomerApiInfos.customer_api_id,
  name: pgCustomerApiInfos.name
});

const convertPgQuestionToQuestion$1 = pgQuestion => ({
  id: pgQuestion.question_id,
  text: pgQuestion.text
});

const convertMongoSmartSkillInfosAndPgCustomerApiToSmartSkillsInfos = (mongoSmartSkillInfos, pgCustomerApiInfos, pgQuestions) => ({
  answers: mongoSmartSkillInfos.answers.map(answer => convertMongoSmartSkillAnswerToSmartSkillAnswer(answer)),
  botId: mongoSmartSkillInfos.bot_id,
  details: {
    apis: pgCustomerApiInfos.map(pgCustomerApiInfo => convertPgCustomerApiInfosToCustomerApiInfo$1(pgCustomerApiInfo)),
    questions: pgQuestions.map(pgQuestion => convertPgQuestionToQuestion$1(pgQuestion))
  },
  id: mongoSmartSkillInfos.smart_skill_id,
  name: mongoSmartSkillInfos.name,
  questions: mongoSmartSkillInfos.questions.map(question => convertMongoSmartSkillQuestionToQuestionData(question))
});

const getOneSmartSkillInfosByBotIdAndSmartSkillId = (mongodb, pool) => async (botId, smartSkillId) => {
  const smartSkill = await getOneSmartSkillInfos$1(mongodb)(botId, smartSkillId);

  if (smartSkill === null) {
    return null;
  }

  const pgCustomerApi = await getManyPgCustomerApiByBotId$1(pool)(botId);
  const pgCustomerApiData = await getManyPgCustomerApiData(pool)(pgCustomerApi);
  const manyPgQuestion = await getManyPgQuestionByBotId$1(pool)(botId);
  return convertMongoSmartSkillInfosAndPgCustomerApiToSmartSkillsInfos(smartSkill, pgCustomerApiData, manyPgQuestion);
};

var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getOneSmartSkillInfosByBotIdAndSmartSkillId: getOneSmartSkillInfosByBotIdAndSmartSkillId
});

const getManyPgCustomerApiByBotId = pool => async botId => {
  try {
    const result = await pool.query(`SELECT
        customer_api_id,
        method,
        name,
        body
      FROM customer_api
      WHERE bot_id = $1
      ORDER BY id ASC;`, [botId]);
    return result.rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getManyPgQuestionByBotId = pool => async botId => {
  try {
    const result = await pool.query(`SELECT
        question_id,
        bot_id,
        text
      FROM question
      WHERE bot_id = (SELECT bot.id FROM bot WHERE bot.bot_id = $1)
      ORDER BY text ASC;`, [botId]);
    return result.rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getManyPgCustomerApiDataByCustomerApiId = pool => async customerApiId => {
  try {
    const result = await pool.query(`SELECT
          name,
          "format",
          "type"
        FROM customer_api_data
        WHERE customer_api_id = (SELECT id FROM customer_api WHERE customer_api_id = $1)
        AND type IN('input','output');`, [customerApiId]);
    return result.rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getManyPgCustomerApiInfos = pool => async pgCustomerApis => Promise.all(pgCustomerApis.map(async pgCustomerApi => {
  const manyPgCustomerApiData = await getManyPgCustomerApiDataByCustomerApiId(pool)(pgCustomerApi.customer_api_id);
  const inputs = manyPgCustomerApiData.filter(pgCustomerApiData => pgCustomerApiData.type === 'input');
  const outputs = manyPgCustomerApiData.filter(pgCustomerApiData => pgCustomerApiData.type === 'output');
  return Object.assign(Object.assign({}, pgCustomerApi), {
    inputs,
    outputs
  });
}));

const convertPgCustomerApiDataInputToCustomerApiInput = pgCustomerApiDataInput => ({
  name: pgCustomerApiDataInput.name,
  type: pgCustomerApiDataInput.format
});

const convertPgCustomerApiDataOutputToCustomerApiOutput = pgCustomerApiDataOutput => ({
  name: pgCustomerApiDataOutput.name,
  type: pgCustomerApiDataOutput.format
});

const convertPgCustomerApiInfosToCustomerApiDetail = pgCustomerApiInfos => {
  switch (pgCustomerApiInfos.method) {
    case 'GET':
      return {
        inputs: pgCustomerApiInfos.inputs.map(input => convertPgCustomerApiDataInputToCustomerApiInput(input)),
        method: pgCustomerApiInfos.method,
        outputs: pgCustomerApiInfos.outputs.map(output => convertPgCustomerApiDataOutputToCustomerApiOutput(output))
      };

    default:
      return {
        body: pgCustomerApiInfos.body,
        inputs: pgCustomerApiInfos.inputs.map(input => convertPgCustomerApiDataInputToCustomerApiInput(input)),
        method: pgCustomerApiInfos.method,
        outputs: pgCustomerApiInfos.outputs.map(output => convertPgCustomerApiDataOutputToCustomerApiOutput(output))
      };
  }
};

const convertPgCustomerApiInfosToCustomerApiInfo = pgCustomerApiInfos => ({
  details: convertPgCustomerApiInfosToCustomerApiDetail(pgCustomerApiInfos),
  id: pgCustomerApiInfos.customer_api_id,
  name: pgCustomerApiInfos.name
});

const convertPgQuestionToQuestion = pgQuestion => ({
  id: pgQuestion.question_id,
  text: pgQuestion.text
});

const convertManyPgInfosToSmartSkillFormDetails = (manyPgCustomerApiInfos, manyPgQuestions) => ({
  apis: manyPgCustomerApiInfos.map(pgCustomerApiInfos => convertPgCustomerApiInfosToCustomerApiInfo(pgCustomerApiInfos)),
  questions: manyPgQuestions.map(pgQuestion => convertPgQuestionToQuestion(pgQuestion))
});

const getSmartSkillFormDetailsByBotId = pool => async botId => {
  const manyPgCustomerApi = await getManyPgCustomerApiByBotId(pool)(botId);
  const manyPgCustomerApiData = await getManyPgCustomerApiInfos(pool)(manyPgCustomerApi);
  const manyPgQuestions = await getManyPgQuestionByBotId(pool)(botId);
  return convertManyPgInfosToSmartSkillFormDetails(manyPgCustomerApiData, manyPgQuestions);
};

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getSmartSkillFormDetailsByBotId: getSmartSkillFormDetailsByBotId
});

var $schema = "http://json-schema.org/draft-07/schema#";
var definitions = {
	RestBotId: {
		type: "string"
	},
	RestSmartSkillId: {
		type: "string"
	},
	RestQuestionId: {
		type: "string"
	},
	RestQuestionDataText: {
		type: "object",
		properties: {
			type: {
				type: "string",
				"const": "text"
			},
			assignment: {
				type: "string"
			},
			title: {
				type: "string"
			}
		},
		required: [
			"type",
			"assignment",
			"title"
		],
		additionalProperties: false
	},
	RestQuestionDataApiInput: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			type: {
				type: "string",
				"enum": [
					"custom",
					"assignment"
				]
			},
			value: {
				type: "string"
			}
		},
		required: [
			"name",
			"type",
			"value"
		],
		additionalProperties: false
	},
	RestQuestionDataApi: {
		type: "object",
		properties: {
			type: {
				type: "string",
				"const": "customer-api"
			},
			inputs: {
				type: "array",
				items: {
					$ref: "#/definitions/RestQuestionDataApiInput"
				}
			},
			id: {
				type: "string"
			}
		},
		required: [
			"type",
			"inputs",
			"id"
		],
		additionalProperties: false
	},
	RestQuestionButtonChoice: {
		type: "object",
		properties: {
			title: {
				type: "string"
			},
			assignment: {
				type: "string"
			}
		},
		required: [
			"title",
			"assignment"
		],
		additionalProperties: false
	},
	RestQuestionDataChoice: {
		type: "object",
		properties: {
			type: {
				type: "string",
				"const": "qr"
			},
			title: {
				type: "string"
			},
			assignment: {
				type: "string"
			},
			buttons: {
				type: "array",
				items: {
					$ref: "#/definitions/RestQuestionButtonChoice"
				}
			}
		},
		required: [
			"type",
			"title",
			"assignment",
			"buttons"
		],
		additionalProperties: false
	},
	RestQuestionData: {
		anyOf: [
			{
				$ref: "#/definitions/RestQuestionDataText"
			},
			{
				$ref: "#/definitions/RestQuestionDataApi"
			},
			{
				$ref: "#/definitions/RestQuestionDataChoice"
			}
		]
	},
	RestAnswerDataApi: {
		type: "object",
		properties: {
			type: {
				type: "string",
				"const": "customer-api"
			},
			id: {
				type: "string"
			}
		},
		required: [
			"type",
			"id"
		],
		additionalProperties: false
	},
	RestAnswerDataText: {
		type: "object",
		properties: {
			type: {
				type: "string",
				"const": "text"
			},
			title: {
				type: "string"
			}
		},
		required: [
			"type",
			"title"
		],
		additionalProperties: false
	},
	RestAnswerDataChoiceLink: {
		type: "object",
		properties: {
			type: {
				type: "string",
				"const": "url"
			},
			title: {
				type: "string"
			},
			url: {
				type: "string"
			},
			target: {
				type: "string",
				"enum": [
					"self",
					"blank"
				]
			}
		},
		required: [
			"type",
			"title",
			"url",
			"target"
		],
		additionalProperties: false
	},
	RestAnswerDataChoiceQuestion: {
		type: "object",
		properties: {
			type: {
				type: "string",
				"const": "question"
			},
			title: {
				type: "string"
			},
			questionId: {
				$ref: "#/definitions/RestQuestionId"
			}
		},
		required: [
			"type",
			"title",
			"questionId"
		],
		additionalProperties: false
	},
	RestAnswerDataChoiceButton: {
		anyOf: [
			{
				$ref: "#/definitions/RestAnswerDataChoiceLink"
			},
			{
				$ref: "#/definitions/RestAnswerDataChoiceQuestion"
			}
		]
	},
	RestAnswerDataChoice: {
		type: "object",
		properties: {
			type: {
				type: "string",
				"const": "button"
			},
			title: {
				type: "string"
			},
			buttons: {
				type: "array",
				items: {
					$ref: "#/definitions/RestAnswerDataChoiceButton"
				}
			}
		},
		required: [
			"type",
			"title",
			"buttons"
		],
		additionalProperties: false
	},
	RestAnswerData: {
		anyOf: [
			{
				$ref: "#/definitions/RestAnswerDataApi"
			},
			{
				$ref: "#/definitions/RestAnswerDataText"
			},
			{
				$ref: "#/definitions/RestAnswerDataChoice"
			}
		]
	},
	RestSimpleScenario: {
		type: "object",
		properties: {
			target: {
				type: "string"
			},
			operator: {
				type: "string",
				"const": "exist"
			}
		},
		required: [
			"target",
			"operator"
		],
		additionalProperties: false
	},
	RestAdvancedScenario: {
		type: "object",
		properties: {
			target: {
				type: "string"
			},
			operator: {
				type: "string",
				"enum": [
					"equal",
					"not_equal",
					"superior",
					"inferior"
				]
			},
			match: {
				type: "string"
			}
		},
		required: [
			"target",
			"operator",
			"match"
		],
		additionalProperties: false
	},
	RestScenarioContent: {
		anyOf: [
			{
				$ref: "#/definitions/RestSimpleScenario"
			},
			{
				$ref: "#/definitions/RestAdvancedScenario"
			}
		]
	},
	RestScenarioSmartSkill: {
		type: "object",
		properties: {
			type: {
				type: "string",
				"enum": [
					"free_input",
					"button"
				]
			},
			content: {
				$ref: "#/definitions/RestScenarioContent"
			}
		},
		required: [
			"type",
			"content"
		],
		additionalProperties: false
	},
	RestScenarioCustomerApi: {
		type: "object",
		properties: {
			type: {
				type: "string",
				"const": "customer_api"
			},
			reference: {
				type: "string"
			},
			content: {
				$ref: "#/definitions/RestScenarioContent"
			}
		},
		required: [
			"type",
			"reference",
			"content"
		],
		additionalProperties: false
	},
	RestScenario: {
		anyOf: [
			{
				$ref: "#/definitions/RestScenarioSmartSkill"
			},
			{
				$ref: "#/definitions/RestScenarioCustomerApi"
			}
		]
	},
	RestSmartSkillAnswer: {
		type: "object",
		properties: {
			scenarios: {
				type: "array",
				items: {
					$ref: "#/definitions/RestScenario"
				}
			},
			answers: {
				type: "array",
				items: {
					$ref: "#/definitions/RestAnswerData"
				}
			}
		},
		required: [
			"scenarios",
			"answers"
		],
		additionalProperties: false
	},
	RestSmartSkill: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/RestSmartSkillId"
			},
			botId: {
				$ref: "#/definitions/RestBotId"
			},
			name: {
				type: "string"
			},
			questions: {
				type: "array",
				items: {
					$ref: "#/definitions/RestQuestionData"
				}
			},
			answers: {
				type: "array",
				items: {
					$ref: "#/definitions/RestSmartSkillAnswer"
				}
			}
		},
		required: [
			"id",
			"botId",
			"name",
			"questions",
			"answers"
		],
		additionalProperties: false
	},
	RestCustomerApiInput: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			type: {
				type: "string",
				"enum": [
					"string",
					"number"
				]
			}
		},
		required: [
			"name",
			"type"
		],
		additionalProperties: false
	},
	RestCustomerApiOutput: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			type: {
				type: "string",
				"enum": [
					"string",
					"number",
					"boolean"
				]
			}
		},
		required: [
			"name",
			"type"
		],
		additionalProperties: false
	},
	RestCustomerApiDataBase: {
		type: "object",
		properties: {
			inputs: {
				type: "array",
				items: {
					$ref: "#/definitions/RestCustomerApiInput"
				}
			},
			outputs: {
				type: "array",
				items: {
					$ref: "#/definitions/RestCustomerApiOutput"
				}
			}
		},
		required: [
			"inputs",
			"outputs"
		],
		additionalProperties: false
	},
	RestCustomerApiDetailGet: {
		type: "object",
		additionalProperties: false,
		properties: {
			method: {
				type: "string",
				"const": "GET"
			},
			inputs: {
				type: "array",
				items: {
					$ref: "#/definitions/RestCustomerApiInput"
				}
			},
			outputs: {
				type: "array",
				items: {
					$ref: "#/definitions/RestCustomerApiOutput"
				}
			}
		},
		required: [
			"inputs",
			"method",
			"outputs"
		]
	},
	RestCustomerApiDetailPost: {
		type: "object",
		additionalProperties: false,
		properties: {
			method: {
				type: "string",
				"const": "POST"
			},
			body: {
				type: "string"
			},
			inputs: {
				type: "array",
				items: {
					$ref: "#/definitions/RestCustomerApiInput"
				}
			},
			outputs: {
				type: "array",
				items: {
					$ref: "#/definitions/RestCustomerApiOutput"
				}
			}
		},
		required: [
			"body",
			"inputs",
			"method",
			"outputs"
		]
	},
	RestCustomerApiDetails: {
		anyOf: [
			{
				$ref: "#/definitions/RestCustomerApiDetailGet"
			},
			{
				$ref: "#/definitions/RestCustomerApiDetailPost"
			}
		]
	},
	RestCustomerApiInfo: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			name: {
				type: "string"
			},
			details: {
				$ref: "#/definitions/RestCustomerApiDetails"
			}
		},
		required: [
			"id",
			"name",
			"details"
		],
		additionalProperties: false
	},
	RestQuestion: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			text: {
				type: "string"
			}
		},
		required: [
			"id",
			"text"
		],
		additionalProperties: false
	},
	RestSmartSkillFormDetails: {
		type: "object",
		properties: {
			apis: {
				type: "array",
				items: {
					$ref: "#/definitions/RestCustomerApiInfo"
				}
			},
			questions: {
				type: "array",
				items: {
					$ref: "#/definitions/RestQuestion"
				}
			}
		},
		required: [
			"apis",
			"questions"
		],
		additionalProperties: false
	},
	RestSmartSkillInfos: {
		type: "object",
		additionalProperties: false,
		properties: {
			details: {
				$ref: "#/definitions/RestSmartSkillFormDetails"
			},
			id: {
				$ref: "#/definitions/RestSmartSkillId"
			},
			botId: {
				$ref: "#/definitions/RestBotId"
			},
			name: {
				type: "string"
			},
			questions: {
				type: "array",
				items: {
					$ref: "#/definitions/RestQuestionData"
				}
			},
			answers: {
				type: "array",
				items: {
					$ref: "#/definitions/RestSmartSkillAnswer"
				}
			}
		},
		required: [
			"answers",
			"botId",
			"details",
			"id",
			"name",
			"questions"
		]
	},
	BotId: {
		type: "string"
	},
	Bot: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/BotId"
			}
		},
		required: [
			"id"
		],
		additionalProperties: false
	},
	CustomerApiId: {
		type: "string"
	},
	SmartSkillId: {
		type: "string"
	},
	QuestionId: {
		type: "string"
	},
	Question: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/QuestionId"
			},
			text: {
				type: "string"
			}
		},
		required: [
			"id",
			"text"
		],
		additionalProperties: false
	},
	CustomerApiInput: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			type: {
				type: "string",
				"enum": [
					"string",
					"number"
				]
			}
		},
		required: [
			"name",
			"type"
		],
		additionalProperties: false
	},
	CustomerApiOutput: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			type: {
				type: "string",
				"enum": [
					"string",
					"number",
					"boolean"
				]
			}
		},
		required: [
			"name",
			"type"
		],
		additionalProperties: false
	},
	CustomerApiDetailGet: {
		type: "object",
		properties: {
			method: {
				type: "string",
				"const": "GET"
			},
			inputs: {
				type: "array",
				items: {
					$ref: "#/definitions/CustomerApiInput"
				}
			},
			outputs: {
				type: "array",
				items: {
					$ref: "#/definitions/CustomerApiOutput"
				}
			}
		},
		required: [
			"method",
			"inputs",
			"outputs"
		],
		additionalProperties: false
	},
	CustomerApiDetailPost: {
		type: "object",
		properties: {
			method: {
				type: "string",
				"const": "POST"
			},
			inputs: {
				type: "array",
				items: {
					$ref: "#/definitions/CustomerApiInput"
				}
			},
			outputs: {
				type: "array",
				items: {
					$ref: "#/definitions/CustomerApiOutput"
				}
			},
			body: {
				type: "string"
			}
		},
		required: [
			"method",
			"inputs",
			"outputs",
			"body"
		],
		additionalProperties: false
	},
	CustomerApiDetail: {
		anyOf: [
			{
				$ref: "#/definitions/CustomerApiDetailGet"
			},
			{
				$ref: "#/definitions/CustomerApiDetailPost"
			}
		]
	},
	CustomerApiInfo: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/CustomerApiId"
			},
			name: {
				type: "string"
			},
			details: {
				$ref: "#/definitions/CustomerApiDetail"
			}
		},
		required: [
			"id",
			"name",
			"details"
		],
		additionalProperties: false
	},
	QuestionDataText: {
		type: "object",
		properties: {
			type: {
				type: "string",
				"const": "text"
			},
			title: {
				type: "string"
			},
			assignment: {
				type: "string"
			}
		},
		required: [
			"type",
			"title",
			"assignment"
		],
		additionalProperties: false
	},
	QuestionDataApiInput: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			type: {
				type: "string",
				"enum": [
					"custom",
					"assignment"
				]
			},
			value: {
				type: "string"
			}
		},
		required: [
			"name",
			"type",
			"value"
		],
		additionalProperties: false
	},
	QuestionDataApi: {
		type: "object",
		properties: {
			type: {
				type: "string",
				"const": "customer-api"
			},
			id: {
				$ref: "#/definitions/CustomerApiId"
			},
			inputs: {
				type: "array",
				items: {
					$ref: "#/definitions/QuestionDataApiInput"
				}
			}
		},
		required: [
			"type",
			"id",
			"inputs"
		],
		additionalProperties: false
	},
	QuestionButtonChoice: {
		type: "object",
		properties: {
			title: {
				type: "string"
			},
			assignment: {
				type: "string"
			}
		},
		required: [
			"title",
			"assignment"
		],
		additionalProperties: false
	},
	QuestionDataChoice: {
		type: "object",
		properties: {
			type: {
				type: "string",
				"const": "qr"
			},
			title: {
				type: "string"
			},
			assignment: {
				type: "string"
			},
			buttons: {
				type: "array",
				items: {
					$ref: "#/definitions/QuestionButtonChoice"
				}
			}
		},
		required: [
			"type",
			"title",
			"assignment",
			"buttons"
		],
		additionalProperties: false
	},
	QuestionData: {
		anyOf: [
			{
				$ref: "#/definitions/QuestionDataText"
			},
			{
				$ref: "#/definitions/QuestionDataApi"
			},
			{
				$ref: "#/definitions/QuestionDataChoice"
			}
		]
	},
	AnswerDataApi: {
		type: "object",
		properties: {
			type: {
				type: "string",
				"const": "customer-api"
			},
			id: {
				$ref: "#/definitions/CustomerApiId"
			}
		},
		required: [
			"type",
			"id"
		],
		additionalProperties: false
	},
	AnswerDataText: {
		type: "object",
		properties: {
			type: {
				type: "string",
				"const": "text"
			},
			title: {
				type: "string"
			}
		},
		required: [
			"type",
			"title"
		],
		additionalProperties: false
	},
	AnswerDataChoiceLink: {
		type: "object",
		properties: {
			type: {
				type: "string",
				"const": "url"
			},
			title: {
				type: "string"
			},
			url: {
				type: "string"
			},
			target: {
				type: "string",
				"enum": [
					"self",
					"blank"
				]
			}
		},
		required: [
			"type",
			"title",
			"url",
			"target"
		],
		additionalProperties: false
	},
	AnswerDataChoiceQuestion: {
		type: "object",
		properties: {
			type: {
				type: "string",
				"const": "question"
			},
			title: {
				type: "string"
			},
			questionId: {
				type: "string"
			}
		},
		required: [
			"type",
			"title",
			"questionId"
		],
		additionalProperties: false
	},
	AnswerDataChoiceButton: {
		anyOf: [
			{
				$ref: "#/definitions/AnswerDataChoiceLink"
			},
			{
				$ref: "#/definitions/AnswerDataChoiceQuestion"
			}
		]
	},
	AnswerDataChoice: {
		type: "object",
		properties: {
			type: {
				type: "string",
				"const": "button"
			},
			title: {
				type: "string"
			},
			buttons: {
				type: "array",
				items: {
					$ref: "#/definitions/AnswerDataChoiceButton"
				}
			}
		},
		required: [
			"type",
			"title",
			"buttons"
		],
		additionalProperties: false
	},
	AnswerData: {
		anyOf: [
			{
				$ref: "#/definitions/AnswerDataApi"
			},
			{
				$ref: "#/definitions/AnswerDataText"
			},
			{
				$ref: "#/definitions/AnswerDataChoice"
			}
		]
	},
	SimpleScenario: {
		type: "object",
		properties: {
			target: {
				type: "string"
			},
			operator: {
				type: "string",
				"const": "exist"
			}
		},
		required: [
			"target",
			"operator"
		],
		additionalProperties: false
	},
	AdvancedScenario: {
		type: "object",
		properties: {
			target: {
				type: "string"
			},
			operator: {
				type: "string",
				"enum": [
					"equal",
					"not_equal",
					"superior",
					"inferior"
				]
			},
			match: {
				type: "string"
			}
		},
		required: [
			"target",
			"operator",
			"match"
		],
		additionalProperties: false
	},
	ScenarioContent: {
		anyOf: [
			{
				$ref: "#/definitions/SimpleScenario"
			},
			{
				$ref: "#/definitions/AdvancedScenario"
			}
		]
	},
	ScenarioSmartSkill: {
		type: "object",
		properties: {
			type: {
				type: "string",
				"enum": [
					"free_input",
					"button"
				]
			},
			content: {
				$ref: "#/definitions/ScenarioContent"
			}
		},
		required: [
			"type",
			"content"
		],
		additionalProperties: false
	},
	ScenarioCustomerApi: {
		type: "object",
		properties: {
			type: {
				type: "string",
				"const": "customer_api"
			},
			reference: {
				type: "string"
			},
			content: {
				$ref: "#/definitions/ScenarioContent"
			}
		},
		required: [
			"type",
			"reference",
			"content"
		],
		additionalProperties: false
	},
	Scenario: {
		anyOf: [
			{
				$ref: "#/definitions/ScenarioSmartSkill"
			},
			{
				$ref: "#/definitions/ScenarioCustomerApi"
			}
		]
	},
	SmartSkillAnswer: {
		type: "object",
		properties: {
			scenarios: {
				type: "array",
				items: {
					$ref: "#/definitions/Scenario"
				}
			},
			answers: {
				type: "array",
				items: {
					$ref: "#/definitions/AnswerData"
				}
			}
		},
		required: [
			"scenarios",
			"answers"
		],
		additionalProperties: false
	},
	SmartSkillData: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			questions: {
				type: "array",
				items: {
					$ref: "#/definitions/QuestionData"
				}
			},
			answers: {
				type: "array",
				items: {
					$ref: "#/definitions/SmartSkillAnswer"
				}
			}
		},
		required: [
			"name",
			"questions",
			"answers"
		],
		additionalProperties: false
	},
	SmartSkillFormDetails: {
		type: "object",
		properties: {
			apis: {
				type: "array",
				items: {
					$ref: "#/definitions/CustomerApiInfo"
				}
			},
			questions: {
				type: "array",
				items: {
					$ref: "#/definitions/Question"
				}
			}
		},
		required: [
			"apis",
			"questions"
		],
		additionalProperties: false
	},
	SmartSkill: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/SmartSkillId"
			},
			botId: {
				$ref: "#/definitions/BotId"
			},
			name: {
				type: "string"
			},
			questions: {
				type: "array",
				items: {
					$ref: "#/definitions/QuestionData"
				}
			},
			answers: {
				type: "array",
				items: {
					$ref: "#/definitions/SmartSkillAnswer"
				}
			}
		},
		required: [
			"id",
			"botId",
			"name",
			"questions",
			"answers"
		],
		additionalProperties: false
	},
	SmartSkillInfos: {
		type: "object",
		additionalProperties: false,
		properties: {
			details: {
				$ref: "#/definitions/SmartSkillFormDetails"
			},
			id: {
				$ref: "#/definitions/SmartSkillId"
			},
			botId: {
				$ref: "#/definitions/BotId"
			},
			name: {
				type: "string"
			},
			questions: {
				type: "array",
				items: {
					$ref: "#/definitions/QuestionData"
				}
			},
			answers: {
				type: "array",
				items: {
					$ref: "#/definitions/SmartSkillAnswer"
				}
			}
		},
		required: [
			"answers",
			"botId",
			"details",
			"id",
			"name",
			"questions"
		]
	},
	SmartSkills: {
		type: "array",
		items: {
			$ref: "#/definitions/SmartSkill"
		}
	},
	MongoBot: {
		type: "object",
		properties: {
			bot_id: {
				type: "string"
			}
		},
		required: [
			"bot_id"
		],
		additionalProperties: false
	},
	PgCustomerApiInput: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			format: {
				type: "string",
				"enum": [
					"string",
					"number"
				]
			}
		},
		required: [
			"name",
			"format"
		],
		additionalProperties: false
	},
	PgCustomerApi: {
		anyOf: [
			{
				$ref: "#/definitions/PgCustomerApiGet"
			},
			{
				$ref: "#/definitions/PgCustomerApiPost"
			}
		]
	},
	PgCustomerApiGet: {
		type: "object",
		properties: {
			customer_api_id: {
				type: "string"
			},
			method: {
				type: "string",
				"const": "GET"
			},
			name: {
				type: "string"
			},
			body: {
				type: "null"
			}
		},
		required: [
			"customer_api_id",
			"method",
			"name",
			"body"
		],
		additionalProperties: false
	},
	PgCustomerApiPost: {
		type: "object",
		properties: {
			customer_api_id: {
				type: "string"
			},
			method: {
				type: "string",
				"const": "POST"
			},
			name: {
				type: "string"
			},
			body: {
				type: "string"
			}
		},
		required: [
			"customer_api_id",
			"method",
			"name",
			"body"
		],
		additionalProperties: false
	},
	PgQuestion: {
		type: "object",
		properties: {
			question_id: {
				type: "string"
			},
			bot_id: {
				type: "string"
			},
			text: {
				type: "string"
			}
		},
		required: [
			"question_id",
			"bot_id",
			"text"
		],
		additionalProperties: false
	},
	MongoAssignmentId: {
		type: "string"
	},
	MongoAssignment: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			id: {
				$ref: "#/definitions/MongoAssignmentId"
			}
		},
		required: [
			"name",
			"id"
		],
		additionalProperties: false
	},
	MongoQuestionApiInputCustom: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			type: {
				type: "string",
				"const": "custom"
			},
			value: {
				type: "string"
			}
		},
		required: [
			"name",
			"type",
			"value"
		],
		additionalProperties: false
	},
	MongoQuestionApiInputAssignment: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			type: {
				type: "string",
				"const": "assignment"
			},
			assignment: {
				$ref: "#/definitions/MongoAssignment"
			}
		},
		required: [
			"name",
			"type",
			"assignment"
		],
		additionalProperties: false
	},
	MongoQuestionApiInput: {
		anyOf: [
			{
				$ref: "#/definitions/MongoQuestionApiInputCustom"
			},
			{
				$ref: "#/definitions/MongoQuestionApiInputAssignment"
			}
		]
	},
	MongoSmartSkillQuestionApi: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			customer_api_id: {
				type: "string"
			},
			type: {
				type: "string",
				"const": "customer-api"
			},
			inputs: {
				type: "array",
				items: {
					$ref: "#/definitions/MongoQuestionApiInput"
				}
			}
		},
		required: [
			"id",
			"customer_api_id",
			"type",
			"inputs"
		],
		additionalProperties: false
	},
	MongoSmartSkillQuestionText: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			label: {
				type: "string"
			},
			assignment: {
				$ref: "#/definitions/MongoAssignment"
			},
			type: {
				type: "string",
				"const": "text"
			}
		},
		required: [
			"id",
			"label",
			"assignment",
			"type"
		],
		additionalProperties: false
	},
	MongoSmartSkillAnswerDataChoiceButtonLink: {
		type: "object",
		properties: {
			type: {
				type: "string",
				"const": "url"
			},
			title: {
				type: "string"
			},
			url: {
				type: "string"
			},
			target: {
				type: "string",
				"enum": [
					"self",
					"blank"
				]
			}
		},
		required: [
			"type",
			"title",
			"url",
			"target"
		],
		additionalProperties: false
	},
	MongoSmartSkillAnswerDataChoiceButtonQuestion: {
		type: "object",
		properties: {
			type: {
				type: "string",
				"const": "question"
			},
			title: {
				type: "string"
			},
			questionId: {
				type: "string"
			}
		},
		required: [
			"type",
			"title",
			"questionId"
		],
		additionalProperties: false
	},
	MongoSmartSkillAnswerDataChoiceButton: {
		anyOf: [
			{
				$ref: "#/definitions/MongoSmartSkillAnswerDataChoiceButtonLink"
			},
			{
				$ref: "#/definitions/MongoSmartSkillAnswerDataChoiceButtonQuestion"
			}
		]
	},
	MongoSmartSkillAnswerDataChoice: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			label: {
				type: "string"
			},
			type: {
				type: "string",
				"const": "button"
			},
			buttons: {
				type: "array",
				items: {
					$ref: "#/definitions/MongoSmartSkillAnswerDataChoiceButton"
				}
			}
		},
		required: [
			"id",
			"label",
			"type",
			"buttons"
		],
		additionalProperties: false
	},
	MongoSmartSkillAnswerText: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			label: {
				type: "string"
			},
			type: {
				type: "string",
				"const": "text"
			}
		},
		required: [
			"id",
			"label",
			"type"
		],
		additionalProperties: false
	},
	MongoSmartSkillAnswerApi: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			customer_api_id: {
				type: "string"
			},
			type: {
				type: "string",
				"const": "customer-api"
			}
		},
		required: [
			"id",
			"customer_api_id",
			"type"
		],
		additionalProperties: false
	},
	MongoSmartSkillQuestionButtonChoice: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			label: {
				type: "string"
			},
			assignment: {
				$ref: "#/definitions/MongoAssignment"
			},
			type: {
				type: "string",
				"const": "payload"
			}
		},
		required: [
			"id",
			"label",
			"assignment",
			"type"
		],
		additionalProperties: false
	},
	MongoSmartSkillQuestionChoice: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			label: {
				type: "string"
			},
			assignment: {
				$ref: "#/definitions/MongoAssignment"
			},
			buttons: {
				type: "array",
				items: {
					$ref: "#/definitions/MongoSmartSkillQuestionButtonChoice"
				}
			},
			type: {
				type: "string",
				"const": "qr"
			}
		},
		required: [
			"id",
			"label",
			"assignment",
			"buttons",
			"type"
		],
		additionalProperties: false
	},
	MongoSmartSkillQuestion: {
		anyOf: [
			{
				$ref: "#/definitions/MongoSmartSkillQuestionText"
			},
			{
				$ref: "#/definitions/MongoSmartSkillQuestionApi"
			},
			{
				$ref: "#/definitions/MongoSmartSkillQuestionChoice"
			}
		]
	},
	MongoSmartSkillAnswerContent: {
		anyOf: [
			{
				$ref: "#/definitions/MongoSmartSkillAnswerText"
			},
			{
				$ref: "#/definitions/MongoSmartSkillAnswerApi"
			},
			{
				$ref: "#/definitions/MongoSmartSkillAnswerDataChoice"
			}
		]
	},
	MongoSmartSkillAnswerItem: {
		type: "object",
		properties: {
			content: {
				type: "array",
				items: {
					$ref: "#/definitions/MongoSmartSkillAnswerContent"
				}
			},
			id: {
				type: "string"
			}
		},
		required: [
			"content",
			"id"
		],
		additionalProperties: false
	},
	MongoSmartSkillAnswerSimpleScenario: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			assignment: {
				$ref: "#/definitions/MongoAssignment"
			},
			operator: {
				type: "string",
				"const": "exist"
			}
		},
		required: [
			"id",
			"assignment",
			"operator"
		],
		additionalProperties: false
	},
	MongoSmartSkillAnswerAdvancedScenario: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			assignment: {
				$ref: "#/definitions/MongoAssignment"
			},
			operator: {
				type: "string",
				"enum": [
					"equal",
					"not_equal",
					"superior",
					"inferior"
				]
			},
			match: {
				type: "string"
			}
		},
		required: [
			"id",
			"assignment",
			"operator",
			"match"
		],
		additionalProperties: false
	},
	MongoSmartSkillAnswerScenarioContent: {
		anyOf: [
			{
				$ref: "#/definitions/MongoSmartSkillAnswerSimpleScenario"
			},
			{
				$ref: "#/definitions/MongoSmartSkillAnswerAdvancedScenario"
			}
		]
	},
	MongoSmartSkillAnswerScenarioSmartSkill: {
		anyOf: [
			{
				type: "object",
				additionalProperties: false,
				properties: {
					type: {
						type: "string",
						"enum": [
							"text",
							"button"
						]
					},
					id: {
						type: "string"
					},
					assignment: {
						$ref: "#/definitions/MongoAssignment"
					},
					operator: {
						type: "string",
						"const": "exist"
					}
				},
				required: [
					"assignment",
					"id",
					"operator",
					"type"
				]
			},
			{
				type: "object",
				additionalProperties: false,
				properties: {
					type: {
						type: "string",
						"enum": [
							"text",
							"button"
						]
					},
					id: {
						type: "string"
					},
					assignment: {
						$ref: "#/definitions/MongoAssignment"
					},
					operator: {
						type: "string",
						"enum": [
							"equal",
							"not_equal",
							"superior",
							"inferior"
						]
					},
					match: {
						type: "string"
					}
				},
				required: [
					"assignment",
					"id",
					"match",
					"operator",
					"type"
				]
			}
		]
	},
	MongoSmartSkillAnswerScenarioCustomerApi: {
		anyOf: [
			{
				type: "object",
				additionalProperties: false,
				properties: {
					type: {
						type: "string",
						"const": "customer_api"
					},
					reference: {
						type: "string"
					},
					id: {
						type: "string"
					},
					assignment: {
						$ref: "#/definitions/MongoAssignment"
					},
					operator: {
						type: "string",
						"const": "exist"
					}
				},
				required: [
					"assignment",
					"id",
					"operator",
					"reference",
					"type"
				]
			},
			{
				type: "object",
				additionalProperties: false,
				properties: {
					type: {
						type: "string",
						"const": "customer_api"
					},
					reference: {
						type: "string"
					},
					id: {
						type: "string"
					},
					assignment: {
						$ref: "#/definitions/MongoAssignment"
					},
					operator: {
						type: "string",
						"enum": [
							"equal",
							"not_equal",
							"superior",
							"inferior"
						]
					},
					match: {
						type: "string"
					}
				},
				required: [
					"assignment",
					"id",
					"match",
					"operator",
					"reference",
					"type"
				]
			}
		]
	},
	MongoSmartSkillAnswerScenario: {
		anyOf: [
			{
				$ref: "#/definitions/MongoSmartSkillAnswerScenarioSmartSkill"
			},
			{
				$ref: "#/definitions/MongoSmartSkillAnswerScenarioCustomerApi"
			}
		]
	},
	MongoSmartSkillAnswer: {
		type: "object",
		properties: {
			answer: {
				$ref: "#/definitions/MongoSmartSkillAnswerItem"
			},
			scenarios: {
				type: "array",
				items: {
					$ref: "#/definitions/MongoSmartSkillAnswerScenario"
				}
			}
		},
		required: [
			"answer",
			"scenarios"
		],
		additionalProperties: false
	},
	MongoSmartSkillInfos: {
		type: "object",
		properties: {
			bot_id: {
				type: "string"
			},
			smart_skill_id: {
				type: "string"
			},
			name: {
				type: "string"
			},
			questions: {
				type: "array",
				items: {
					$ref: "#/definitions/MongoSmartSkillQuestion"
				}
			},
			answers: {
				type: "array",
				items: {
					$ref: "#/definitions/MongoSmartSkillAnswer"
				}
			}
		},
		required: [
			"bot_id",
			"smart_skill_id",
			"name",
			"questions",
			"answers"
		],
		additionalProperties: false
	},
	PgCustomerApiDataInput: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			format: {
				type: "string",
				"enum": [
					"string",
					"number"
				]
			},
			type: {
				type: "string",
				"const": "input"
			}
		},
		required: [
			"name",
			"format",
			"type"
		],
		additionalProperties: false
	},
	PgCustomerApiDataOutput: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			format: {
				type: "string",
				"enum": [
					"string",
					"number",
					"boolean"
				]
			},
			type: {
				type: "string",
				"const": "output"
			}
		},
		required: [
			"name",
			"format",
			"type"
		],
		additionalProperties: false
	},
	PgCustomerApiData: {
		anyOf: [
			{
				$ref: "#/definitions/PgCustomerApiDataInput"
			},
			{
				$ref: "#/definitions/PgCustomerApiDataOutput"
			}
		]
	},
	PgCustomerApiInfos: {
		anyOf: [
			{
				type: "object",
				additionalProperties: false,
				properties: {
					inputs: {
						type: "array",
						items: {
							$ref: "#/definitions/PgCustomerApiDataInput"
						}
					},
					outputs: {
						type: "array",
						items: {
							$ref: "#/definitions/PgCustomerApiDataOutput"
						}
					},
					customer_api_id: {
						type: "string"
					},
					method: {
						type: "string",
						"const": "GET"
					},
					name: {
						type: "string"
					},
					body: {
						type: "null"
					}
				},
				required: [
					"body",
					"customer_api_id",
					"inputs",
					"method",
					"name",
					"outputs"
				]
			},
			{
				type: "object",
				additionalProperties: false,
				properties: {
					inputs: {
						type: "array",
						items: {
							$ref: "#/definitions/PgCustomerApiDataInput"
						}
					},
					outputs: {
						type: "array",
						items: {
							$ref: "#/definitions/PgCustomerApiDataOutput"
						}
					},
					customer_api_id: {
						type: "string"
					},
					method: {
						type: "string",
						"const": "POST"
					},
					name: {
						type: "string"
					},
					body: {
						type: "string"
					}
				},
				required: [
					"body",
					"customer_api_id",
					"inputs",
					"method",
					"name",
					"outputs"
				]
			}
		]
	},
	MongoSmartSkill: {
		type: "object",
		properties: {
			smart_skill_id: {
				type: "string"
			},
			bot_id: {
				type: "string"
			},
			name: {
				type: "string"
			},
			answers: {
				type: "array",
				items: {
					$ref: "#/definitions/MongoSmartSkillAnswer"
				}
			},
			questions: {
				type: "array",
				items: {
					$ref: "#/definitions/MongoSmartSkillQuestion"
				}
			}
		},
		required: [
			"smart_skill_id",
			"bot_id",
			"name",
			"answers",
			"questions"
		],
		additionalProperties: false
	}
};
var entitiesSchemas = {
	$schema: $schema,
	definitions: definitions
};

var entitiesSchemas$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  $schema: $schema,
  definitions: definitions,
  'default': entitiesSchemas
});

const smartSkillFactory = (botId, smartSkillData) => Object.assign(Object.assign({}, smartSkillData), {
  botId,
  id: genericUtils.generateUniqueId()
});

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  smartSkillFactory: smartSkillFactory
});

/* eslint-disable max-lines */
var ValidateSmartSkillAnswerErrors;

(function (ValidateSmartSkillAnswerErrors) {
  ValidateSmartSkillAnswerErrors[ValidateSmartSkillAnswerErrors["emptyAnswers"] = 0] = "emptyAnswers";
  ValidateSmartSkillAnswerErrors[ValidateSmartSkillAnswerErrors["invalidScenarios"] = 1] = "invalidScenarios";
  ValidateSmartSkillAnswerErrors[ValidateSmartSkillAnswerErrors["invalidAnswerData"] = 2] = "invalidAnswerData";
  ValidateSmartSkillAnswerErrors[ValidateSmartSkillAnswerErrors["invalidButtons"] = 3] = "invalidButtons";
})(ValidateSmartSkillAnswerErrors || (ValidateSmartSkillAnswerErrors = {}));

var ValidateQuestionDataErrors;

(function (ValidateQuestionDataErrors) {
  ValidateQuestionDataErrors[ValidateQuestionDataErrors["emptyTitle"] = 0] = "emptyTitle";
  ValidateQuestionDataErrors[ValidateQuestionDataErrors["emptyAssignment"] = 1] = "emptyAssignment";
  ValidateQuestionDataErrors[ValidateQuestionDataErrors["inexistingCustomerApi"] = 2] = "inexistingCustomerApi";
  ValidateQuestionDataErrors[ValidateQuestionDataErrors["invalidInputs"] = 3] = "invalidInputs";
  ValidateQuestionDataErrors[ValidateQuestionDataErrors["invalidType"] = 4] = "invalidType";
})(ValidateQuestionDataErrors || (ValidateQuestionDataErrors = {}));

var ValidateScenarioErrors;

(function (ValidateScenarioErrors) {
  ValidateScenarioErrors[ValidateScenarioErrors["invalidType"] = 0] = "invalidType";
  ValidateScenarioErrors[ValidateScenarioErrors["emptyReference"] = 1] = "emptyReference";
  ValidateScenarioErrors[ValidateScenarioErrors["emptyContentScenario"] = 2] = "emptyContentScenario";
  ValidateScenarioErrors[ValidateScenarioErrors["invalidScenario"] = 3] = "invalidScenario";
})(ValidateScenarioErrors || (ValidateScenarioErrors = {}));

var ValidateScenarioContentErrors;

(function (ValidateScenarioContentErrors) {
  ValidateScenarioContentErrors[ValidateScenarioContentErrors["emptyTarget"] = 0] = "emptyTarget";
  ValidateScenarioContentErrors[ValidateScenarioContentErrors["invalidOperator"] = 1] = "invalidOperator";
  ValidateScenarioContentErrors[ValidateScenarioContentErrors["emptyMatch"] = 2] = "emptyMatch";
})(ValidateScenarioContentErrors || (ValidateScenarioContentErrors = {}));

var ValidateAnswerDataErrors;

(function (ValidateAnswerDataErrors) {
  ValidateAnswerDataErrors[ValidateAnswerDataErrors["emptyTitle"] = 0] = "emptyTitle";
  ValidateAnswerDataErrors[ValidateAnswerDataErrors["inexistingCustomerApi"] = 1] = "inexistingCustomerApi";
  ValidateAnswerDataErrors[ValidateAnswerDataErrors["invalidType"] = 2] = "invalidType";
  ValidateAnswerDataErrors[ValidateAnswerDataErrors["emptyButtons"] = 3] = "emptyButtons";
  ValidateAnswerDataErrors[ValidateAnswerDataErrors["invalidButtons"] = 4] = "invalidButtons";
})(ValidateAnswerDataErrors || (ValidateAnswerDataErrors = {}));

var ValidateAnswerDataChoiceButtonErrors;

(function (ValidateAnswerDataChoiceButtonErrors) {
  ValidateAnswerDataChoiceButtonErrors[ValidateAnswerDataChoiceButtonErrors["invalidUrl"] = 0] = "invalidUrl";
  ValidateAnswerDataChoiceButtonErrors[ValidateAnswerDataChoiceButtonErrors["inexistingQuestion"] = 1] = "inexistingQuestion";
  ValidateAnswerDataChoiceButtonErrors[ValidateAnswerDataChoiceButtonErrors["invalidTypeButton"] = 2] = "invalidTypeButton";
})(ValidateAnswerDataChoiceButtonErrors || (ValidateAnswerDataChoiceButtonErrors = {}));

const isAllRequiredInputNamesInQuestionData = (questionDataApiInputs, customerApiInputs) => customerApiInputs.map(customerApiInput => questionDataApiInputs.some(questionDataApiInput => questionDataApiInput.name === customerApiInput.name)).filter(customerApiInputValidation => customerApiInputValidation === false).length === genericUtils.ARRAY.EMPTY_LENGTH;

const validateQuestionData = (getOneCustomerApiByIdAndBotId, getManyCustomerApiInputsByCustomerApiId) => async (questionData, botId) => {
  switch (questionData.type) {
    case 'text':
      if (genericUtils.isEmpty(questionData.title)) {
        return ValidateQuestionDataErrors.emptyTitle;
      }

      if (genericUtils.isEmpty(questionData.assignment)) {
        return ValidateQuestionDataErrors.emptyAssignment;
      }

      break;

    case 'customer-api':
      {
        const customerApiId = await getOneCustomerApiByIdAndBotId(botId, questionData.id);

        if (customerApiId === null) {
          return ValidateQuestionDataErrors.inexistingCustomerApi;
        }

        const customerApiInputs = await getManyCustomerApiInputsByCustomerApiId(customerApiId);
        const validInputs = isAllRequiredInputNamesInQuestionData(questionData.inputs, customerApiInputs);

        if (validInputs === false) {
          return ValidateQuestionDataErrors.invalidInputs;
        }

        break;
      }

    case 'qr':
      {
        if (genericUtils.isEmpty(questionData.title)) {
          return ValidateQuestionDataErrors.emptyTitle;
        }

        if (genericUtils.isEmpty(questionData.assignment)) {
          return ValidateQuestionDataErrors.emptyAssignment;
        }

        break;
      }

    default:
      return ValidateQuestionDataErrors.invalidType;
  }
};

const someQuestionDataAreNotValid = (getOneCustomerApiByIdAndBotId, getManyCustomerApiInputsByCustomerApiId) => async (questionDatas, botId) => {
  const questionsDatasValidation = (await Promise.all(questionDatas.map(async questionData => validateQuestionData(getOneCustomerApiByIdAndBotId, getManyCustomerApiInputsByCustomerApiId)(questionData, botId)))).filter(questionData => typeof questionData !== 'undefined');
  return questionsDatasValidation.length > genericUtils.ARRAY.EMPTY_LENGTH;
};

const validateScenarioContent = scenarioContent => {
  switch (scenarioContent.operator) {
    case 'exist':
      if (genericUtils.isEmpty(scenarioContent.target)) {
        return ValidateScenarioContentErrors.emptyTarget;
      }

      if (genericUtils.isEmpty(scenarioContent.operator)) {
        return ValidateScenarioContentErrors.invalidOperator;
      }

      break;

    default:
      if (genericUtils.isEmpty(scenarioContent.target)) {
        return ValidateScenarioContentErrors.emptyTarget;
      }

      if (genericUtils.isEmpty(scenarioContent.operator)) {
        return ValidateScenarioContentErrors.invalidOperator;
      }

      if (genericUtils.isEmpty(scenarioContent.match)) {
        return ValidateScenarioContentErrors.emptyMatch;
      }

  }
};

const validateScenario = scenario => {
  switch (scenario.type) {
    case 'customer_api':
      {
        if (genericUtils.isEmpty(scenario.reference)) {
          return ValidateScenarioErrors.emptyReference;
        }

        if (genericUtils.isEmpty(scenario.content)) {
          return ValidateScenarioErrors.emptyContentScenario;
        }

        const validScenarioContentres = validateScenarioContent(scenario.content);

        if (typeof validScenarioContentres !== 'undefined') {
          return ValidateScenarioErrors.invalidScenario;
        }

        break;
      }

    case 'free_input':
    case 'button':
      {
        if (genericUtils.isEmpty(scenario.content)) {
          return ValidateScenarioErrors.emptyContentScenario;
        }

        const validScenarioContent = validateScenarioContent(scenario.content);

        if (typeof validScenarioContent !== 'undefined') {
          return ValidateScenarioErrors.invalidScenario;
        }

        break;
      }

    default:
      return ValidateScenarioErrors.invalidType;
  }
};

const validateAnswerDataChoiceButton = getOneQuestionByIdAndBotId => async answerDataChoiceButton => {
  switch (answerDataChoiceButton.type) {
    case 'url':
      if (!genericUtils.isWebsiteUrlValid(answerDataChoiceButton.url)) {
        return ValidateAnswerDataChoiceButtonErrors.invalidUrl;
      }

      break;

    case 'question':
      {
        const question = await getOneQuestionByIdAndBotId(answerDataChoiceButton.questionId);

        if (question === null) {
          return ValidateAnswerDataChoiceButtonErrors.inexistingQuestion;
        }

        break;
      }

    default:
      return ValidateAnswerDataChoiceButtonErrors.invalidTypeButton;
  }
};

const someAnswerDataChoiceButtonNotValid = getOneQuestionByIdAndBotId => async buttons => {
  const answerDataChoiceButtoValidation = await Promise.all(buttons.map(async button => validateAnswerDataChoiceButton(getOneQuestionByIdAndBotId)(button)));
  const errors = answerDataChoiceButtoValidation.filter(error => typeof error !== 'undefined');
  return errors.length > genericUtils.ARRAY.EMPTY_LENGTH;
};

const validateAnswerData = (getOneCustomerApiByIdAndBotId, getOneQuestionByIdAndBotId) => async (answerData, botId) => {
  switch (answerData.type) {
    case 'text':
      if (genericUtils.isEmpty(answerData.title)) {
        return ValidateAnswerDataErrors.emptyTitle;
      }

      break;

    case 'customer-api':
      {
        const customerApi = await getOneCustomerApiByIdAndBotId(botId, answerData.id);

        if (customerApi === null) {
          return ValidateAnswerDataErrors.inexistingCustomerApi;
        }

        break;
      }

    case 'button':
      {
        if (genericUtils.isEmpty(answerData.title)) {
          return ValidateAnswerDataErrors.emptyTitle;
        }

        if (genericUtils.isEmpty(answerData.buttons)) {
          return ValidateAnswerDataErrors.emptyButtons;
        }

        const someAnswerDataChoiceButtonNotValidErrors = await someAnswerDataChoiceButtonNotValid(getOneQuestionByIdAndBotId)(answerData.buttons);

        if (someAnswerDataChoiceButtonNotValidErrors === true) {
          return ValidateAnswerDataErrors.invalidButtons;
        }

        break;
      }

    default:
      return ValidateAnswerDataErrors.invalidType;
  }
};

const someScenariosAreNotValid = scenarios => scenarios.map(scenario => validateScenario(scenario)).filter(scenario => typeof scenario !== 'undefined').length > genericUtils.ARRAY.EMPTY_LENGTH;

const someAnswersAreNotValid = (getOneCustomerApiByIdAndBotId, getOneQuestionByIdAndBotId) => async (answers, botId) => {
  const answerDatasValidation = (await Promise.all(answers.map(async answer => validateAnswerData(getOneCustomerApiByIdAndBotId, getOneQuestionByIdAndBotId)(answer, botId)))).filter(answer => typeof answer !== 'undefined');
  return answerDatasValidation.length > genericUtils.ARRAY.EMPTY_LENGTH;
};

const validateSmartSkillAnswer = (getOneCustomerApiByIdAndBotId, getOneQuestionByIdAndBotId) => async (smartSkillAnswer, botId) => {
  if (genericUtils.isEmpty(smartSkillAnswer.answers)) {
    return ValidateSmartSkillAnswerErrors.emptyAnswers;
  }

  if (someScenariosAreNotValid(smartSkillAnswer.scenarios)) {
    return ValidateSmartSkillAnswerErrors.invalidScenarios;
  }

  if (await someAnswersAreNotValid(getOneCustomerApiByIdAndBotId, getOneQuestionByIdAndBotId)(smartSkillAnswer.answers, botId)) {
    return ValidateSmartSkillAnswerErrors.invalidAnswerData;
  }
};

const someSmartSkillAnswersAreNotValid = (getOneCustomerApiByIdAndBotId, getOneQuestionByIdAndBotId) => async (smartSkillAnswers, botId) => {
  const smartSkillAnswersValidation = (await Promise.all(smartSkillAnswers.map(async smartSkillAnswer => validateSmartSkillAnswer(getOneCustomerApiByIdAndBotId, getOneQuestionByIdAndBotId)(smartSkillAnswer, botId)))).filter(smartSkillAnswer => typeof smartSkillAnswer !== 'undefined');
  return smartSkillAnswersValidation.length > genericUtils.ARRAY.EMPTY_LENGTH;
};

var ValidateSmartSkillDataErrors;

(function (ValidateSmartSkillDataErrors) {
  ValidateSmartSkillDataErrors[ValidateSmartSkillDataErrors["invalidQuestionData"] = 0] = "invalidQuestionData";
  ValidateSmartSkillDataErrors[ValidateSmartSkillDataErrors["invalidSmartSkillAnswer"] = 1] = "invalidSmartSkillAnswer";
})(ValidateSmartSkillDataErrors || (ValidateSmartSkillDataErrors = {}));

const validateSmartSkillData = (getOneCustomerApiByIdAndBotId, getManyCustomerApiInputsByCustomerApiId, getOneQuestionByIdAndBotId) => async (smartSkillData, botId) => {
  if ((await someQuestionDataAreNotValid(getOneCustomerApiByIdAndBotId, getManyCustomerApiInputsByCustomerApiId)(smartSkillData.questions, botId)) === true) {
    return ValidateSmartSkillDataErrors.invalidQuestionData;
  }

  if ((await someSmartSkillAnswersAreNotValid(getOneCustomerApiByIdAndBotId, getOneQuestionByIdAndBotId)(smartSkillData.answers, botId)) === true) {
    return ValidateSmartSkillDataErrors.invalidSmartSkillAnswer;
  }
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  validateSmartSkillData: validateSmartSkillData,
  get ValidateSmartSkillDataErrors () { return ValidateSmartSkillDataErrors; }
});

const getManySmartSkills = (getOneBotById, getManySmartSkillsByBotId) => async botId => {
  const bot = await getOneBotById(botId);

  if (bot === null) {
    return GetManySmartSkillsErrors.inexistingBot;
  }

  return getManySmartSkillsByBotId(botId);
};

const getOneSmartSkillInfos = getOneSmartSkillInfosByBotIdAndSmartSkillId => async (botId, smartSkillId) => {
  const smartSkillInfos = await getOneSmartSkillInfosByBotIdAndSmartSkillId(botId, smartSkillId);

  if (smartSkillInfos === null) {
    return GetOneSmartSkillInfosErrors.inexistingSmartSkill;
  }

  return smartSkillInfos;
};

const getSmartSkillFormDetails = (getOneBotById, getSmartSkillFormDetailsByBotId) => async botId => {
  const bot = await getOneBotById(botId);

  if (bot === null) {
    return GetSmartSkillFormDetailsErrors.inexistingBot;
  }

  return getSmartSkillFormDetailsByBotId(botId);
};

const createOneSmartSkill = (getOneBotById, validateSmartSkillData, saveSmartSkill, smartSkillFactory) => async (botId, smartSkillData) => {
  const bot = await getOneBotById(botId);

  if (bot === null) {
    return CreateOneSmartSkillErrors.inexistingBot;
  }

  if (genericUtils.isEmpty(smartSkillData.name)) {
    return CreateOneSmartSkillErrors.emptyName;
  }

  if (genericUtils.isEmpty(smartSkillData.questions)) {
    return CreateOneSmartSkillErrors.emptyQuestions;
  }

  if (typeof (await validateSmartSkillData(smartSkillData, botId)) !== 'undefined') {
    return CreateOneSmartSkillErrors.invalidSmartSkill;
  }

  const smartSkill = smartSkillFactory(botId, smartSkillData);
  await saveSmartSkill(smartSkill);
  return smartSkill.id;
};

const updateOneSmartSkill = (getOneSmartSkillByBotIdAndId, validateSmartSkillData, saveSmartSkill, setValueModifiedOnOneBot) => async (botId, smartSkillId, smartSkillData) => {
  const smartskill = await getOneSmartSkillByBotIdAndId(botId, smartSkillId);

  if (smartskill === null) {
    return UpdateOneSmartSkillErrors.inexistingSmartSkill;
  }

  if (genericUtils.isEmpty(smartSkillData.name)) {
    return UpdateOneSmartSkillErrors.emptyName;
  }

  if (genericUtils.isEmpty(smartSkillData.questions)) {
    return UpdateOneSmartSkillErrors.emptyQuestions;
  }

  if (typeof (await validateSmartSkillData(smartSkillData, botId)) !== 'undefined') {
    return UpdateOneSmartSkillErrors.invalidSmartSkill;
  }

  await saveSmartSkill(Object.assign(Object.assign({}, smartskill), smartSkillData));
  await setValueModifiedOnOneBot(botId);
};

export { applicationPorts as appPorts, createOneSmartSkill, entitiesSchemas$1 as entitiesSchemas, getManySmartSkills, getOneSmartSkillInfos, getSmartSkillFormDetails, index$7 as mongodbBotsRepository, index$3 as mongodbPostgreSqlSmartSkillsRepository, index$4 as mongodbSmartSkillsRepository, index$6 as postgreSqlCustomerApiRepository, index$5 as postgreSqlQuestionsRepository, index$2 as postgreSqlSmartSkillsRepository, index$1 as smartSkill, index$8 as smartSkillAxios, index as smartSkillsValidationService, updateOneSmartSkill };
